import { Typography, Box, Divider } from '@mui/material';
import CodeBlock from '../../CodeBlock';

function RetrievalOverview() {
  return (
    <Box sx={{ textAlign: 'left', maxWidth: '900px' }}>
      <Typography variant="subtitle1" gutterBottom color="text.secondary">
        EUDR SOAP Version 1.3 - REST API Implementation
      </Typography>

      <Typography variant="body1" paragraph sx={{ my: 3 }}>
        The Retrieval Service allows you to fetch information about existing DDS statements using various identifiers.
        This service provides several endpoints to retrieve DDS statements based on different search criteria.
      </Typography>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="600">
        Retrieval Endpoints:
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Get DDS Info by UUIDs
      </Typography> 
      <Typography variant="body1" paragraph sx={{ mt: 2 }}>
        Retrieves up to 100 statements using UUIDs from previous submissions
      </Typography>
      <ul>
        <li>Returns reference numbers, verification codes, and internal references</li>
        <li>UUIDs must come from successful submissions</li>
      </ul>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Get DDS Info by Reference
      </Typography> 
      <Typography variant="body1" paragraph sx={{ mt: 2 }}>
        Search by your internal reference number (3-50 chars)
      </Typography>
      <ul>
        <li>Supports partial matching (e.g. "FR-2024" finds all FR-2024* references)</li>
        <li>Returns up to 1000 matching results</li>
        <li>Case-insensitive search</li>
      </ul>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Get Statement by Identifiers
      </Typography> 
      <Typography variant="body1" paragraph sx={{ mt: 2 }}>
        Full statement retrieval using official reference + verification
      </Typography>
      <ul>
        <li>Returns complete submission data including operator details</li>
        <li>Only available for statements with "Available" status</li>
      </ul>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" gutterBottom sx={{ mb: 2 }} fontWeight="500">
        Authentication
      </Typography>
      <Typography variant="body1" paragraph>
        All requests require an API key in the Authorization header:
      </Typography>
      <CodeBlock code="Authorization: Bearer your-api-key-here" />
    </Box>
  );
}

export default RetrievalOverview; 